import { LinkProps } from 'react-router-dom';
import Layout from 'layouts';
import { Container, Box, styled, Typography, Button, Grid } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';
import ProfileBG from 'assets/images/graphic-profile-bg.svg';
import NotificationCentre from 'components/NotificationCentre';

const pageBgColor = palette.blue[400];

export const StyledLayout = styled(Layout)`
  background: ${pageBgColor} url(${ProfileBG}) bottom center no-repeat;
  background-size: contain;
`;

export const StyledContainer = styled(Container)`
  padding: 2rem 1rem !important;

  ${theme.breakpoints.up('md')} {
    padding-top: 100px !important;
  }
`;

export const PageHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  ${theme.breakpoints.up('md')} {
    margin-bottom: 40px;
  }
`;

export const PageTitle = styled(Typography)`
  color: ${theme.palette.white};
  margin: 0;
`;

export const StyledButton = styled(Button)<LinkProps>`
  &:hover svg {
    color: ${theme.palette.neutral.dark};
  }
`;

export const SettingsCog = styled(SettingsIcon)`
  color: ${theme.palette.white};
  font-size: 35px;
  transition: color 0.3s ease-in;
`;

export const StyledGrid = styled(Grid)`
  width: 100%;
`;

export const StyledNotificationCentre = styled(NotificationCentre)`
  padding: 0;

  ${theme.breakpoints.up('md')} {
    padding: 0 1rem;
  }
`;
